module.exports = __webpack_public_path__ + "img/public_hero_blob_mobile.854fd57.png";